function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
  fill: "#6c533a"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m153.9375 300.601562 55.609375 55.613282-79.472656 79.472656 70.21875 70.214844c17.933593 3.980468 36.574219 6.097656 55.707031 6.097656 141.386719 0 256-114.613281 256-256 0-7.292969-.320312-14.511719-.921875-21.652344l-145.441406-145.445312zm0 0",
  fill: "#593927"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m187.222656 259.867188 68.777344 175.765624h126.089844v-175.765624zm0 0",
  fill: "#9b918b"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m129.910156 259.867188h126.089844v175.765624h-126.089844zm0 0",
  fill: "#bdb5b2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m336.238281 412.707031h-80.238281l-22.925781-45.851562 103.164062 22.925781zm0 0",
  fill: "#bdb5b2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m256 412.707031h-80.238281v-22.925781l80.238281-22.925781zm0 0",
  fill: "#d6d0cd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m210.148438 278.972656 45.851562 110.808594h80.238281v-81.847656zm0 0",
  fill: "#bdb5b2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m175.761719 285.007812h80.238281v104.773438h-80.238281zm0 0",
  fill: "#d6d0cd"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m267.464844 343.929688h22.925781v34.390624h-22.925781zm0 0",
  fill: "#593927"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m221.609375 343.929688h22.925781v34.390624h-22.925781zm0 0",
  fill: "#7a6c64"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m336.238281 290.4375h-22.925781v76.417969h-57.3125l-15.285156 11.464843 15.285156 11.460938h80.238281zm0 0",
  fill: "#593927"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m198.6875 366.855469v-76.417969h-22.925781v99.34375h80.238281v-22.925781zm0 0",
  fill: "#7a6c64"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m256 44.367188-45.851562 157.421874 45.851562 111.574219h45.851562c61.519532 0 111.570313-50.050781 111.570313-111.574219 0-86.800781-70.617187-157.421874-157.421875-157.421874zm0 0",
  fill: "#bdb5b2"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m98.578125 201.789062c0 61.523438 50.050781 111.574219 111.570313 111.574219h45.851562v-268.996093c-86.804688 0-157.421875 70.621093-157.421875 157.421874zm0 0",
  fill: "#d6d0cd"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m244.535156 252.226562h22.929688v38.210938h-22.929688zm0 0",
  fill: "#7a6c64"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m367.570312 201.789062c0 25.535157-20.699218 46.234376-46.230468 46.234376-25.535156 0-46.234375-20.699219-46.234375-46.234376 0-25.535156 20.699219-46.234374 46.234375-46.234374 25.53125 0 46.230468 20.699218 46.230468 46.234374zm0 0",
  fill: "#480306"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m236.894531 201.789062c0 25.535157-20.699219 46.234376-46.234375 46.234376-25.53125 0-46.230468-20.699219-46.230468-46.234376 0-25.535156 20.699218-46.234374 46.230468-46.234374 25.535156 0 46.234375 20.699218 46.234375 46.234374zm0 0",
  fill: "#593927"
});

var SvgMonster = function SvgMonster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMonster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/monster.8ae02e33.svg";
export { ForwardRef as ReactComponent };